/**
 * @generated SignedSource<<a8f1e0247dad05a3264cc2906fbe2e69>>
 * @relayHash 8b8c38c7a22dce7456580a037f4b2a62
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d77d6176b659359d2321c3d2a388ede962ae07219ab1f053817592810c44263a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoardQuery } from './JiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d77d6176b659359d2321c3d2a388ede962ae07219ab1f053817592810c44263a",
    "metadata": {},
    "name": "JiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
